// // // import React, { useState } from 'react';
// // // import '../Sidebar.css';
// // // import authService from './services/authService';
// // // import { Link } from 'react-router-dom';
// // // import { useAuth } from './AuthContext';





// // // const Sidebar = () => {
// // //   const [dropdowns, setDropdowns] = useState({
// // //     admission: false,
// // //     attendance: false,
// // //     exam: false,
// // //     fee: false
// // //   });

// // //   const [isSidebarVisible, setIsSidebarVisible] = useState(false);

// // //   const { user } = useAuth();

// // //   const toggleDropdown = (name) => {
// // //     setDropdowns(prevState => {
// // //       const newState = {
// // //         admission: false,
// // //         attendance: false,
// // //         exam: false,
// // //         fee: false,
// // //       };
// // //       newState[name] = !prevState[name];
// // //       return newState;
// // //     });
// // //   };

// // //   const toggleSidebar = () => {
// // //     setIsSidebarVisible(!isSidebarVisible);
// // //   };



// // //   const handleLogout = () => {
// // //     authService.logout();
// // //     window.location.reload();
// // //   };



// // //   return (
// // //     <>
// // //       <div className={`sidebar ${isSidebarVisible ? 'show' : 'hide'} ${user.user.user_type == 'Student' || user.user.user_type == 'Teacher' ? 'd-none' : ''}`}>

// // //         <h4 className='p-2 text-center' style={{background:'#EBD197'}}> <Link to="/" className="dropdown-item" style={{color:'black', fontWeight: 'bolder'}}>Dashboard</Link></h4>
        
// // //         {user && user.user.user_type =='Admin' && (
// // //         <div className='pl-3'>
// // //           <div className="sidebar-item" onClick={() => toggleDropdown('admission')}>
// // //             <i className="fas fa-graduation-cap"></i>
// // //             <a href="#">Student Information</a>
// // //             <i className={`icon-arrow ${dropdowns.admission ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.admission && (
// // //             <div className="dropdown">
// // //               <Link to="/admission-form" className="dropdown-item">Create Admission</Link>
// // //               <Link to="/promote-students" className="dropdown-item">Promote Students</Link>
// // //               <Link to="/admission-list" className="dropdown-item">Admission List</Link>
// // //               <Link to="/create-class" className="dropdown-item">Create Class</Link>
// // //               <Link to="/create-section" className="dropdown-item">Create Section</Link>
// // //               <Link to="/create-fee-group" className="dropdown-item">Create Fee Group</Link>
// // //               <Link to="/select-categories" className="dropdown-item">Create Categories</Link>
// // //               <Link to="/student-id-card-generate" className="dropdown-item">Student ID Card</Link>
// // //               <Link to="/student-accounts" className="dropdown-item">Student Accounts</Link>
// // //               <Link to="/create-house-and-club" className="dropdown-item">Create House/Club</Link>
// // //             </div>
// // //           )}

// // //           <div className="sidebar-item" onClick={() => toggleDropdown('attendance')}>
// // //             <i className="fas fa-chalkboard-teacher"></i>
// // //             <a href="#">Attendance</a>
// // //             <i className={`icon-arrow ${dropdowns.attendance ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.attendance && (
// // //             <div className="dropdown">
// // //               <Link to="/student-attendance-list" className="dropdown-item">Student Attendance</Link>
// // //               <Link to="/attendance-list" className="dropdown-item">Employee Attendance</Link>
// // //             </div>
// // //           )}

// // //           <div className="sidebar-item" onClick={() => toggleDropdown('exam')}>
// // //             <i className="fas fa-book"></i>
// // //             <a href="#">Exam</a>
// // //             <i className={`icon-arrow ${dropdowns.exam ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.exam && (
// // //             <div className="dropdown">
// // //               <a href="#" className="dropdown-item">Create Exam</a>
// // //               <a href="#" className="dropdown-item">Add Marks</a>
// // //               <a href="#" className="dropdown-item">Exam Report</a>
// // //             </div>
// // //           )}

// // //           <div className="sidebar-item" onClick={() => toggleDropdown('fee')}>
// // //             <i className="fas fa-receipt"></i>
// // //             <a href="#">Fee</a>
// // //             <i className={`icon-arrow ${dropdowns.fee ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.fee && (
// // //             <div className="dropdown">
// // //               <Link to="/bank-details-form" className="dropdown-item">Bank Detail</Link>
// // //               <Link to="/bank-notes" className="dropdown-item">Voucher Notes</Link>
// // //               {/* <Link to="/fee-fine" className="dropdown-item">Fee Fine</Link> */}
// // //               {/* <a href="#" className="dropdown-item">Bank Branch</a> */}
// // //               <Link to="/heads" className="dropdown-item">Fee Head</Link>
// // //               <Link to="/fee-head-details" className="dropdown-item">Fee Head Details</Link>
// // //               <Link to="/fee-generate" className="dropdown-item">Fee Generate</Link>
// // //               {/* <Link to="/single-fee-generate" className="dropdown-item">Single Fee Generate</Link> */}
// // //               {/* <Link to="/edit-fee-voucher" className="dropdown-item">Edit Fee Voucher</Link> */}
// // //               <Link to="/fee-vouchers" className="dropdown-item">Fee Vouchers</Link>
// // //               <Link to="/fee-post" className="dropdown-item">Fee Post</Link>
// // //               <Link to="/fee-post-all" className="dropdown-item">Fee Post All</Link>
// // //               <Link to="/fee-reports" className="dropdown-item">Fee Reports</Link>
// // //             </div>
// // //           )}


// // //           <div className="sidebar-item" onClick={() => toggleDropdown('hr')}>
// // //             <i className="fas fa-users"></i>
// // //             <a href="#">HR</a>
// // //             <i className={`icon-arrow ${dropdowns.hr ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.hr && (
// // //             <div className="dropdown">
// // //               <Link to="/employee-form" className="dropdown-item">Add Employee</Link>
// // //               <Link to="/employee-list" className="dropdown-item">Employee List</Link>
// // //               <Link to="/employee-id-card-generate" className="dropdown-item">Employee ID Card</Link>
// // //               {/* <Link to="/pay-scale-wise-basic-salary" className="dropdown-item">Create Basic Salary</Link> */}
// // //               <Link to="/increments-pay-scale-wise" className="dropdown-item">Increments</Link>
// // //               <Link to="/overtime" className="dropdown-item">Overtime</Link>
// // //               <Link to="/salary-of-employee" className="dropdown-item">Generate Salary</Link>
// // //               <Link to="/school-salary-list" className="dropdown-item">Salary List</Link>
// // //                <Link to="/employee-discipline-form" className="dropdown-item">Employee Discipline</Link>
// // //               <Link to="/salary-reports" className="dropdown-item">Salary Report</Link>
// // //             </div>
// // //           )}



// // //           <div className="sidebar-item" onClick={() => toggleDropdown('academics')}>
// // //           <i class="fas fa-pen"></i>

// // //             <a href="#">Academics</a>
// // //             <i className={`icon-arrow ${dropdowns.academics ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.academics && (
// // //             <div className="dropdown">
// // //               <Link to="/create-subject" className="dropdown-item">Create Subject</Link>
// // //               <Link to="/assign-subjects" className="dropdown-item">Assign Subject</Link>
// // //               <Link to="/assign-subject-teacher" className="dropdown-item">Assign Subject Teacher</Link>
// // //               <Link to="/create-timetable" className="dropdown-item">Create Time Table</Link>
// // //               <Link to="/student-activities" className="dropdown-item">Student Activities</Link>
// // //                <Link to="/student-discipline-form" className="dropdown-item">Student Discipline</Link>
// // //             </div>
            
// // //           )}



// // //         <div className="sidebar-item" onClick={() => toggleDropdown('finance')}>
// // //             <i className="fas fa-balance-scale"></i>
// // //             <a href="#">Finance</a>
// // //             <i className={`icon-arrow ${dropdowns.finance ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.finance && (
// // //             <div className="dropdown">
// // //               <Link to="/charts-of-account-head" className="dropdown-item">Charts Of Account (Heads)</Link>
// // //               <Link to="/charts-of-account" className="dropdown-item">Charts Of Account</Link>
// // //               <Link to="/create-voucher" className="dropdown-item">Create Voucher</Link>
// // //               <Link to="/finance-report" className="dropdown-item">Finance Report</Link>
// // //             </div>
// // //           )}


// // //         </div>
// // //         )}



// // // {user && user.user.user_type =='Student' && (
// // //         <div className='pl-3'>
// // //           <div className="sidebar-item" onClick={() => toggleDropdown('lms')}>
// // //             <i className="fas fa-graduation-cap"></i>
// // //             <a href="#">LMS</a>
// // //             <i className={`icon-arrow ${dropdowns.lms ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.lms && (
// // //             <div className="dropdown">
// // //               <Link to="/student-profile" className="dropdown-item">Student Profile</Link>
// // //               <Link to="/promote-students" className="dropdown-item">Time Table</Link>
// // //               <Link to="/admission-list" className="dropdown-item">Class Syllabus</Link>
// // //               <Link to="/create-class" className="dropdown-item">Fee Vouchers</Link>
// // //               <Link to="/create-section" className="dropdown-item">Home Work</Link>
// // //             </div>
// // //           )}

          

// // //         </div>
// // //         )}



// // //         <div className='pl-3'>

// // //         <div className="sidebar-item" onClick={() => toggleDropdown('auth')}>
// // //                     <i className="fas fa-lock"></i>
// // //                     <a href="#">Auth</a>
// // //                     <i className={`icon-arrow ${dropdowns.auth ? 'open' : ''}`}></i>
// // //                   </div>
// // //                   {dropdowns.auth && (
// // //                     <div className="dropdown">
// // //                         <Link to="/add-campus-information" className="dropdown-item">Campus Information</Link>
// // //                        <Link to="/view-logs" className="dropdown-item">Logs</Link>
// // //                         <a href="#" className="dropdown-item" onClick={handleLogout}>Logout</a>
// // //                     </div>
// // //                   )}
// // //           </div>


// // //       </div>

// // //       {user && user.user.user_type !=='Student' && (
// // //       <button className="toggle-button" onClick={toggleSidebar}>
// // //         {isSidebarVisible ? 'Hide' : 'Show'}
// // //       </button>
// // //       )}
// // //     </>
// // //   );
// // // };

// // // export default Sidebar;




// // // import React, { useState } from 'react';
// // // import '../Sidebar.css';
// // // import authService from './services/authService';
// // // import { Link } from 'react-router-dom';
// // // import { useAuth } from './AuthContext';

// // // const Sidebar = () => {
// // //   const [dropdowns, setDropdowns] = useState({
// // //     admission: false,
// // //     attendance: false,
// // //     exam: false,
// // //     fee: false,
// // //     hr: false,
// // //     academics: false,
// // //     finance: false,
// // //     lms: false,
// // //     auth: false,
// // //   });

// // //   const [isSidebarVisible, setIsSidebarVisible] = useState(false);

// // //   const { user } = useAuth();

// // //   const toggleDropdown = (name) => {
// // //     setDropdowns(prevState => {
// // //       const newState = {
// // //         admission: false,
// // //         attendance: false,
// // //         exam: false,
// // //         fee: false,
// // //         hr: false,
// // //         academics: false,
// // //         finance: false,
// // //         lms: false,
// // //         auth: false,
// // //       };
// // //       newState[name] = !prevState[name];
// // //       return newState;
// // //     });
// // //   };

// // //   const toggleSidebar = () => {
// // //     setIsSidebarVisible(!isSidebarVisible);
// // //   };

// // //   const handleLogout = () => {
// // //     authService.logout();
// // //     window.location.reload();
// // //   };

// // //   return (
// // //     <>
// // //       <div className={`sidebar ${isSidebarVisible ? 'show' : 'hide'} ${user.user.user_type == 'Student' || user.user.user_type == 'Teacher' ? 'd-none' : ''}`}>
// // //         <h4 className='p-2 text-center' style={{background:'#EBD197'}}> 
// // //           <Link to="/" className="dropdown-item" style={{color:'black', fontWeight: 'bolder'}}>
// // //             <i className="fas fa-tachometer-alt"></i> Dashboard
// // //           </Link>
// // //         </h4>
        
// // //         {user && user.user.user_type == 'Admin' && (
// // //           <div className='pl-3'>
// // //             <div className="sidebar-item" onClick={() => toggleDropdown('admission')}>
// // //               <i className="fas fa-graduation-cap"></i>
// // //               <a href="#">Student Information</a>
// // //               <i className={`icon-arrow ${dropdowns.admission ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.admission && (
// // //               <div className="dropdown">
// // //                 <Link to="/admission-form" className="dropdown-item"><i className="fas fa-user-plus"></i> Create Admission</Link>
// // //                 <Link to="/promote-students" className="dropdown-item"><i className="fas fa-arrow-up"></i> Promote Students</Link>
// // //                 <Link to="/admission-list" className="dropdown-item"><i className="fas fa-list"></i> Admission List</Link>
// // //                 <Link to="/create-class" className="dropdown-item"><i className="fas fa-chalkboard"></i> Create Class</Link>
// // //                 <Link to="/create-section" className="dropdown-item"><i className="fas fa-object-group"></i> Create Section</Link>
// // //                 <Link to="/create-fee-group" className="dropdown-item"><i className="fas fa-money-bill"></i> Create Fee Group</Link>
// // //                 <Link to="/select-categories" className="dropdown-item"><i className="fas fa-tags"></i> Create Categories</Link>
// // //                 <Link to="/student-id-card-generate" className="dropdown-item"><i className="fas fa-id-card"></i> Student ID Card</Link>
// // //                 <Link to="/student-accounts" className="dropdown-item"><i className="fas fa-user-shield"></i> Student Accounts</Link>
// // //                 <Link to="/create-house-and-club" className="dropdown-item"><i className="fas fa-home"></i> Create House/Club</Link>
// // //               </div>
// // //             )}

// // //             <div className="sidebar-item" onClick={() => toggleDropdown('attendance')}>
// // //               <i className="fas fa-chalkboard-teacher"></i>
// // //               <a href="#">Attendance</a>
// // //               <i className={`icon-arrow ${dropdowns.attendance ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.attendance && (
// // //               <div className="dropdown">
// // //                 <Link to="/student-attendance-list" className="dropdown-item"><i className="fas fa-user-check"></i> Student Attendance</Link>
// // //                 <Link to="/attendance-list" className="dropdown-item"><i className="fas fa-users"></i> Employee Attendance</Link>
// // //                 <Link to="/real-time-attendance-dashboard" className="dropdown-item"><i className="fas fa-users"></i> Biometric (DB)</Link>
// // //               </div>
// // //             )}

// // //             <div className="sidebar-item" onClick={() => toggleDropdown('exam')}>
// // //               <i className="fas fa-book"></i>
// // //               <a href="#">Exam</a>
// // //               <i className={`icon-arrow ${dropdowns.exam ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.exam && (
// // //               <div className="dropdown">
// // //                 <a href="#" className="dropdown-item"><i className="fas fa-plus-circle"></i> Create Exam</a>
// // //                 <a href="#" className="dropdown-item"><i className="fas fa-marker"></i> Add Marks</a>
// // //                 <a href="#" className="dropdown-item"><i className="fas fa-file-alt"></i> Exam Report</a>
// // //               </div>
// // //             )}

// // //             <div className="sidebar-item" onClick={() => toggleDropdown('fee')}>
// // //               <i className="fas fa-receipt"></i>
// // //               <a href="#">Fee</a>
// // //               <i className={`icon-arrow ${dropdowns.fee ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.fee && (
// // //               <div className="dropdown">
// // //                 <Link to="/bank-details-form" className="dropdown-item"><i className="fas fa-university"></i> Bank Detail</Link>
// // //                 <Link to="/bank-notes" className="dropdown-item"><i className="fas fa-sticky-note"></i> Voucher Notes</Link>
// // //                 <Link to="/heads" className="dropdown-item"><i className="fas fa-money-check-alt"></i> Fee Head</Link>
// // //                 <Link to="/fee-head-details" className="dropdown-item"><i className="fas fa-info-circle"></i> Fee Head Details</Link>
// // //                 <Link to="/fee-generate" className="dropdown-item"><i className="fas fa-file-invoice-dollar"></i> Fee Generate</Link>
// // //                 <Link to="/fee-vouchers" className="dropdown-item"><i className="fas fa-ticket-alt"></i> Fee Vouchers</Link>
// // //                 <Link to="/fee-post" className="dropdown-item"><i className="fas fa-upload"></i> Fee Post</Link>
// // //                 <Link to="/fee-post-all" className="dropdown-item"><i className="fas fa-cloud-upload-alt"></i> Fee Post All</Link>
// // //                 <Link to="/fee-reports" className="dropdown-item"><i className="fas fa-chart-bar"></i> Fee Reports</Link>
// // //               </div>
// // //             )}

// // //             <div className="sidebar-item" onClick={() => toggleDropdown('hr')}>
// // //               <i className="fas fa-users"></i>
// // //               <a href="#">HR</a>
// // //               <i className={`icon-arrow ${dropdowns.hr ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.hr && (
// // //               <div className="dropdown">
// // //                 <Link to="/employee-form" className="dropdown-item"><i className="fas fa-user-plus"></i> Add Employee</Link>
// // //                 <Link to="/employee-list" className="dropdown-item"><i className="fas fa-users"></i> Employee List</Link>
// // //                 <Link to="/employee-id-card-generate" className="dropdown-item"><i className="fas fa-id-card"></i> Employee ID Card</Link>
// // //                 <Link to="/increments-pay-scale-wise" className="dropdown-item"><i className="fas fa-arrow-up"></i> Increments</Link>
// // //                 <Link to="/overtime" className="dropdown-item"><i className="fas fa-clock"></i> Overtime</Link>
// // //                 <Link to="/salary-of-employee" className="dropdown-item"><i className="fas fa-money-check"></i> Generate Salary</Link>
// // //                 <Link to="/school-salary-list" className="dropdown-item"><i className="fas fa-list-alt"></i> Salary List</Link>
// // //                 <Link to="/employee-discipline-form" className="dropdown-item"><i className="fas fa-user-shield"></i> Employee Discipline</Link>
// // //                 <Link to="/salary-reports" className="dropdown-item"><i className="fas fa-chart-line"></i> Salary Report</Link>
// // //               </div>
// // //             )}


// // //              <div className="sidebar-item" onClick={() => toggleDropdown('website')}>
// // //               <i className="fas fa-users"></i>
// // //               <a href="#">Website</a>
// // //               <i className={`icon-arrow ${dropdowns.website ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.website && (
// // //               <div className="dropdown">
// // //                 <Link to="/notification" className="dropdown-item"><i class="fas fa-bell"></i> Notification</Link>
// // //                  <Link to="/event-photos-get" className="dropdown-item"><i class="fas fa-bell"></i> Events Photo</Link>
// // //                   <Link to="/apply-now-list" className="dropdown-item"><i class="fas fa-list"></i> Apply Now List</Link>
// // //               </div>
              
// // //             )}

// // //             <div className="sidebar-item" onClick={() => toggleDropdown('academics')}>
// // //               <i className="fas fa-pen"></i>
// // //               <a href="#">Academics</a>
// // //               <i className={`icon-arrow ${dropdowns.academics ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.academics && (
// // //               <div className="dropdown">
// // //                 <Link to="/create-subject" className="dropdown-item"><i className="fas fa-book-open"></i> Create Subject</Link>
// // //                 <Link to="/assign-subjects" className="dropdown-item"><i className="fas fa-tasks"></i> Assign Subject</Link>
// // //                 <Link to="/assign-subject-teacher" className="dropdown-item"><i className="fas fa-chalkboard-teacher"></i> Assign Subject Teacher</Link>
// // //                 <Link to="/create-timetable" className="dropdown-item"><i className="fas fa-calendar-alt"></i> Create Time Table</Link>
// // //                 <Link to="/student-activities" className="dropdown-item"><i className="fas fa-running"></i> Student Activities</Link>
// // //                 <Link to="/student-discipline-form" className="dropdown-item"><i className="fas fa-user-shield"></i> Student Discipline</Link>
// // //               </div>
// // //             )}

// // //             <div className="sidebar-item" onClick={() => toggleDropdown('finance')}>
// // //               <i className="fas fa-balance-scale"></i>
// // //               <a href="#">Finance</a>
// // //               <i className={`icon-arrow ${dropdowns.finance ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.finance && (
// // //               <div className="dropdown">
// // //                 <Link to="/charts-of-account-head" className="dropdown-item"><i className="fas fa-sitemap"></i> COA (Head)</Link>
// // //                 <Link to="/charts-of-account" className="dropdown-item"><i className="fas fa-stream"></i> Charts Of Account</Link>
// // //                 <Link to="/create-voucher" className="dropdown-item"><i className="fas fa-file-invoice"></i> Create Voucher</Link>
// // //                 <Link to="/finance-report" className="dropdown-item"><i className="fas fa-chart-pie"></i> Finance Report</Link>
// // //               </div>
// // //             )}
// // //           </div>
// // //         )}

// // //         {user && user.user.user_type == 'Student' && (
// // //           <div className='pl-3'>
// // //             <div className="sidebar-item" onClick={() => toggleDropdown('lms')}>
// // //               <i className="fas fa-graduation-cap"></i>
// // //               <a href="#">LMS</a>
// // //               <i className={`icon-arrow ${dropdowns.lms ? 'open' : ''}`}></i>
// // //             </div>
// // //             {dropdowns.lms && (
// // //               <div className="dropdown">
// // //                 <Link to="/student-profile" className="dropdown-item"><i className="fas fa-user"></i> Student Profile</Link>
// // //                 <Link to="/promote-students" className="dropdown-item"><i className="fas fa-calendar-alt"></i> Time Table</Link>
// // //                 <Link to="/admission-list" className="dropdown-item"><i className="fas fa-book"></i> Class Syllabus</Link>
// // //                 <Link to="/create-class" className="dropdown-item"><i className="fas fa-ticket-alt"></i> Fee Vouchers</Link>
// // //                 <Link to="/create-section" className="dropdown-item"><i className="fas fa-book-open"></i> Home Work</Link>
// // //               </div>
// // //             )}
// // //           </div>
// // //         )}

// // //         <div className='pl-3'>
// // //           <div className="sidebar-item" onClick={() => toggleDropdown('auth')}>
// // //             <i className="fas fa-lock"></i>
// // //             <a href="#">Auth</a>
// // //             <i className={`icon-arrow ${dropdowns.auth ? 'open' : ''}`}></i>
// // //           </div>
// // //           {dropdowns.auth && (
// // //             <div className="dropdown">
// // //               <Link to="/add-campus-information" className="dropdown-item"><i className="fas fa-school"></i> Campus Information</Link>
// // //               <Link to="/view-logs" className="dropdown-item"><i className="fas fa-history"></i> Logs</Link>
// // //               <a href="#" className="dropdown-item" onClick={handleLogout}><i className="fas fa-sign-out-alt"></i> Logout</a>
// // //             </div>
// // //           )}
// // //         </div>
// // //       </div>

// // //       {user && user.user.user_type !== 'Student' && (
// // //         <button className="toggle-button" onClick={toggleSidebar}>
// // //           {isSidebarVisible ? 'Hide' : 'Show'}
// // //         </button>
// // //       )}
// // //     </>
// // //   );
// // // };

// // // export default Sidebar;








// // import React, { useState } from 'react';
// // import { Link, useLocation } from 'react-router-dom';
// // import { useAuth } from './AuthContext';
// // import authService from './services/authService';

// // const menuItems = {
// //   Admin: [
// //     {
// //       key: 'admission',
// //       label: 'Student Information',
// //       icon: '🎓',
// //       links: [
// //         { to: '/admission-form', icon: '➕', label: 'Create Admission' },
// //         { to: '/promote-students', icon: '⬆️', label: 'Promote Students' },
// //         { to: '/admission-list', icon: '📋', label: 'Admission List' },
// //         { to: '/create-class', icon: '🏫', label: 'Create Class' },
// //         { to: '/create-section', icon: '🗂️', label: 'Create Section' },
// //         { to: '/create-fee-group', icon: '💰', label: 'Create Fee Group' },
// //         { to: '/select-categories', icon: '🏷️', label: 'Create Categories' },
// //         { to: '/student-id-card-generate', icon: '🪪', label: 'Student ID Card' },
// //         { to: '/student-accounts', icon: '👤', label: 'Student Accounts' },
// //         { to: '/create-house-and-club', icon: '🏠', label: 'Create House/Club' },
// //       ],
// //     },
// //     {
// //       key: 'attendance',
// //       label: 'Attendance',
// //       icon: '✅',
// //       links: [
// //         { to: '/student-attendance-list', icon: '🧑‍🎓', label: 'Student Attendance' },
// //         { to: '/attendance-list', icon: '👥', label: 'Employee Attendance' },
// //         { to: '/real-time-attendance-dashboard', icon: '📡', label: 'Biometric (DB)' },
// //       ],
// //     },
// //     {
// //       key: 'exam',
// //       label: 'Exam',
// //       icon: '📝',
// //       links: [
// //         { to: '#', icon: '➕', label: 'Create Exam' },
// //         { to: '#', icon: '✏️', label: 'Add Marks' },
// //         { to: '#', icon: '📄', label: 'Exam Report' },
// //       ],
// //     },
// //     {
// //       key: 'fee',
// //       label: 'Fee',
// //       icon: '🧾',
// //       links: [
// //         { to: '/bank-details-form', icon: '🏦', label: 'Bank Detail' },
// //         { to: '/bank-notes', icon: '📌', label: 'Voucher Notes' },
// //         { to: '/heads', icon: '💳', label: 'Fee Head' },
// //         { to: '/fee-head-details', icon: 'ℹ️', label: 'Fee Head Details' },
// //         { to: '/fee-generate', icon: '🧮', label: 'Fee Generate' },
// //         { to: '/fee-vouchers', icon: '🎟️', label: 'Fee Vouchers' },
// //         { to: '/fee-post', icon: '📤', label: 'Fee Post' },
// //         { to: '/fee-post-all', icon: '☁️', label: 'Fee Post All' },
// //         { to: '/fee-reports', icon: '📊', label: 'Fee Reports' },
// //       ],
// //     },
// //     {
// //       key: 'hr',
// //       label: 'HR',
// //       icon: '👥',
// //       links: [
// //         { to: '/employee-form', icon: '➕', label: 'Add Employee' },
// //         { to: '/employee-list', icon: '👥', label: 'Employee List' },
// //         { to: '/employee-id-card-generate', icon: '🪪', label: 'Employee ID Card' },
// //         { to: '/increments-pay-scale-wise', icon: '⬆️', label: 'Increments' },
// //         { to: '/overtime', icon: '⏰', label: 'Overtime' },
// //         { to: '/salary-of-employee', icon: '💵', label: 'Generate Salary' },
// //         { to: '/school-salary-list', icon: '📋', label: 'Salary List' },
// //         { to: '/employee-discipline-form', icon: '🛡️', label: 'Employee Discipline' },
// //         { to: '/salary-reports', icon: '📈', label: 'Salary Report' },
// //       ],
// //     },
// //     {
// //       key: 'website',
// //       label: 'Website',
// //       icon: '🌐',
// //       links: [
// //         { to: '/notification', icon: '🔔', label: 'Notification' },
// //         { to: '/event-photos-get', icon: '🖼️', label: 'Events Photo' },
// //         { to: '/apply-now-list', icon: '📋', label: 'Apply Now List' },
// //       ],
// //     },
// //     {
// //       key: 'academics',
// //       label: 'Academics',
// //       icon: '📚',
// //       links: [
// //         { to: '/create-subject', icon: '📖', label: 'Create Subject' },
// //         { to: '/assign-subjects', icon: '✅', label: 'Assign Subject' },
// //         { to: '/assign-subject-teacher', icon: '👨‍🏫', label: 'Assign Subject Teacher' },
// //         { to: '/create-timetable', icon: '📅', label: 'Create Time Table' },
// //         { to: '/student-activities', icon: '🏃', label: 'Student Activities' },
// //         { to: '/student-discipline-form', icon: '🛡️', label: 'Student Discipline' },
// //       ],
// //     },
// //     {
// //       key: 'finance',
// //       label: 'Finance',
// //       icon: '⚖️',
// //       links: [
// //         { to: '/charts-of-account-head', icon: '🗂️', label: 'COA (Head)' },
// //         { to: '/charts-of-account', icon: '📊', label: 'Charts Of Account' },
// //         { to: '/create-voucher', icon: '🧾', label: 'Create Voucher' },
// //         { to: '/finance-report', icon: '📉', label: 'Finance Report' },
// //       ],
// //     },
// //   ],
// //   Student: [
// //     {
// //       key: 'lms',
// //       label: 'LMS',
// //       icon: '🎓',
// //       links: [
// //         { to: '/student-profile', icon: '👤', label: 'Student Profile' },
// //         { to: '/promote-students', icon: '📅', label: 'Time Table' },
// //         { to: '/admission-list', icon: '📚', label: 'Class Syllabus' },
// //         { to: '/fee-vouchers', icon: '🎟️', label: 'Fee Vouchers' },
// //         { to: '/create-section', icon: '📖', label: 'Home Work' },
// //       ],
// //     },
// //   ],
// // };

// // const authMenu = [
// //   { to: '/add-campus-information', icon: '🏫', label: 'Campus Information' },
// //   { to: '/view-logs', icon: '🕓', label: 'Logs' },
// // ];

// // export default function Sidebar() {
// //   const [openKey, setOpenKey] = useState(null);
// //   const [sidebarOpen, setSidebarOpen] = useState(false);
// //   const { user } = useAuth();
// //   const location = useLocation();

// //   const userType = user?.user?.user_type;
// //   const isStudentOrTeacher = userType === 'Student' || userType === 'Teacher';

// //   const toggle = (key) => setOpenKey(openKey === key ? null : key);

// //   const handleLogout = () => {
// //     authService.logout();
// //     window.location.reload();
// //   };

// //   const items = menuItems[userType] || [];

// //   return (
// //     <>
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');

// //         :root {
// //           --green-50: #f0fdf4;
// //           --green-100: #dcfce7;
// //           --green-200: #bbf7d0;
// //           --green-300: #86efac;
// //           --green-400: #4ade80;
// //           --green-500: #22c55e;
// //           --green-600: #16a34a;
// //           --green-700: #15803d;
// //           --sidebar-w: 260px;
// //           --transition: 0.25s cubic-bezier(.4,0,.2,1);
// //         }

// //         * { box-sizing: border-box; margin: 0; padding: 0; }

// //         .sb-root {
// //           font-family: 'Nunito', sans-serif;
// //         }

// //         /* ── Overlay ── */
// //         .sb-overlay {
// //           display: none;
// //           position: fixed; inset: 0;
// //           background: rgba(0,0,0,.35);
// //           z-index: 998;
// //           backdrop-filter: blur(2px);
// //         }
// //         .sb-overlay.active { display: block; }

// //         /* ── Sidebar ── */
// //         .sb-wrap {
// //           position: fixed;
// //           top: 0; left: 0;
// //           height: 100vh;
// //           width: var(--sidebar-w);
// //           background: #fff;
// //           border-right: 1.5px solid var(--green-100);
// //           display: flex;
// //           flex-direction: column;
// //           z-index: 999;
// //           transform: translateX(-100%);
// //           transition: transform var(--transition);
// //           box-shadow: 4px 0 24px rgba(34,197,94,.08);
// //           overflow: hidden;
// //         }
// //         .sb-wrap.open { transform: translateX(0); }

// //         @media (min-width: 1024px) {
// //           .sb-wrap { transform: translateX(0); }
// //         }

// //         /* ── Logo / Brand ── */
// //         .sb-brand {
// //           padding: 20px 20px 16px;
// //           background: linear-gradient(135deg, var(--green-600), var(--green-500));
// //           display: flex;
// //           align-items: center;
// //           gap: 10px;
// //           flex-shrink: 0;
// //         }
// //         .sb-brand-icon {
// //           width: 38px; height: 38px;
// //           background: rgba(255,255,255,.2);
// //           border-radius: 10px;
// //           display: flex; align-items: center; justify-content: center;
// //           font-size: 18px;
// //           flex-shrink: 0;
// //         }
// //         .sb-brand-text { color: #fff; }
// //         .sb-brand-text h2 {
// //           font-size: 15px; font-weight: 800;
// //           line-height: 1.2; letter-spacing: -.3px;
// //         }
// //         .sb-brand-text span { font-size: 11px; opacity: .85; font-weight: 500; }

// //         /* ── Dashboard link ── */
// //         .sb-dashboard {
// //           margin: 14px 12px 6px;
// //           display: flex; align-items: center; gap: 10px;
// //           padding: 10px 14px;
// //           border-radius: 10px;
// //           background: var(--green-50);
// //           border: 1.5px solid var(--green-100);
// //           color: var(--green-700);
// //           font-size: 13px; font-weight: 700;
// //           text-decoration: none;
// //           transition: background var(--transition);
// //           flex-shrink: 0;
// //         }
// //         .sb-dashboard:hover { background: var(--green-100); }

// //         /* ── Scrollable nav ── */
// //         .sb-nav {
// //           flex: 1; overflow-y: auto;
// //           padding: 4px 12px 16px;
// //           scrollbar-width: thin;
// //           scrollbar-color: var(--green-200) transparent;
// //         }
// //         .sb-nav::-webkit-scrollbar { width: 4px; }
// //         .sb-nav::-webkit-scrollbar-thumb {
// //           background: var(--green-200); border-radius: 4px;
// //         }

// //         /* ── Section label ── */
// //         .sb-section-label {
// //           font-size: 10px; font-weight: 700;
// //           color: #9ca3af; letter-spacing: .8px;
// //           text-transform: uppercase;
// //           padding: 12px 6px 4px;
// //         }

// //         /* ── Menu group ── */
// //         .sb-group { margin-bottom: 2px; }

// //         .sb-group-btn {
// //           width: 100%;
// //           display: flex; align-items: center; gap: 10px;
// //           padding: 9px 12px;
// //           border: none; background: transparent;
// //           border-radius: 9px;
// //           cursor: pointer;
// //           font-family: 'Nunito', sans-serif;
// //           font-size: 13px; font-weight: 600;
// //           color: #374151;
// //           transition: background var(--transition), color var(--transition);
// //           text-align: left;
// //         }
// //         .sb-group-btn:hover,
// //         .sb-group-btn.active {
// //           background: var(--green-50);
// //           color: var(--green-700);
// //         }
// //         .sb-group-icon { font-size: 16px; flex-shrink: 0; }
// //         .sb-group-label { flex: 1; }
// //         .sb-group-arrow {
// //           font-size: 10px;
// //           transition: transform var(--transition);
// //           color: #9ca3af;
// //         }
// //         .sb-group-arrow.open { transform: rotate(180deg); }

// //         /* ── Dropdown ── */
// //         .sb-dropdown {
// //           overflow: hidden;
// //           max-height: 0;
// //           transition: max-height 0.3s cubic-bezier(.4,0,.2,1);
// //         }
// //         .sb-dropdown.open { max-height: 600px; }

// //         .sb-link {
// //           display: flex; align-items: center; gap: 9px;
// //           padding: 7px 12px 7px 36px;
// //           border-radius: 8px;
// //           color: #4b5563;
// //           text-decoration: none;
// //           font-size: 12.5px; font-weight: 500;
// //           transition: background var(--transition), color var(--transition);
// //           margin-bottom: 1px;
// //         }
// //         .sb-link:hover,
// //         .sb-link.active-link {
// //           background: var(--green-50);
// //           color: var(--green-700);
// //         }
// //         .sb-link.active-link {
// //           background: var(--green-100);
// //           font-weight: 700;
// //         }
// //         .sb-link-icon { font-size: 13px; }

// //         /* ── Divider ── */
// //         .sb-divider {
// //           height: 1px;
// //           background: var(--green-100);
// //           margin: 8px 0;
// //         }

// //         /* ── Auth / logout ── */
// //         .sb-footer {
// //           padding: 8px 12px 16px;
// //           border-top: 1.5px solid var(--green-100);
// //           flex-shrink: 0;
// //         }
// //         .sb-footer-link {
// //           display: flex; align-items: center; gap: 9px;
// //           padding: 8px 12px;
// //           border-radius: 9px;
// //           color: #4b5563;
// //           text-decoration: none;
// //           font-size: 12.5px; font-weight: 600;
// //           transition: background var(--transition), color var(--transition);
// //           margin-bottom: 2px;
// //           background: transparent; border: none; cursor: pointer;
// //           font-family: 'Nunito', sans-serif; width: 100%; text-align: left;
// //         }
// //         .sb-footer-link:hover { background: var(--green-50); color: var(--green-700); }
// //         .sb-footer-link.logout:hover { background: #fef2f2; color: #dc2626; }

// //         /* ── Toggle button ── */
// //         .sb-toggle {
// //           position: fixed;
// //           top: 14px; left: 14px;
// //           z-index: 1000;
// //           width: 42px; height: 42px;
// //           border-radius: 10px;
// //           background: var(--green-600);
// //           color: #fff;
// //           border: none; cursor: pointer;
// //           font-size: 18px;
// //           display: flex; align-items: center; justify-content: center;
// //           box-shadow: 0 4px 14px rgba(22,163,74,.35);
// //           transition: background var(--transition), transform var(--transition);
// //         }
// //         .sb-toggle:hover { background: var(--green-700); transform: scale(1.05); }

// //         @media (min-width: 1024px) {
// //           .sb-toggle { display: none; }
// //         }
// //       `}</style>

// //       <div className="sb-root">
// //         {/* Mobile overlay */}
// //         <div
// //           className={`sb-overlay ${sidebarOpen ? 'active' : ''}`}
// //           onClick={() => setSidebarOpen(false)}
// //         />

// //         {/* Sidebar */}
// //         {!isStudentOrTeacher && (
// //           <aside className={`sb-wrap ${sidebarOpen ? 'open' : ''}`}>
// //             {/* Brand */}
// //             <div className="sb-brand">
// //               <div className="sb-brand-icon">🏫</div>
// //               <div className="sb-brand-text">
// //                 <h2>School ERP</h2>
// //                 <span>Management System</span>
// //               </div>
// //             </div>

// //             {/* Dashboard */}
// //             <Link to="/" className="sb-dashboard" onClick={() => setSidebarOpen(false)}>
// //               🏠 <span>Dashboard</span>
// //             </Link>

// //             {/* Nav */}
// //             <nav className="sb-nav">
// //               {userType === 'Admin' && (
// //                 <div className="sb-section-label">Main Menu</div>
// //               )}

// //               {items.map((group) => (
// //                 <div className="sb-group" key={group.key}>
// //                   <button
// //                     className={`sb-group-btn ${openKey === group.key ? 'active' : ''}`}
// //                     onClick={() => toggle(group.key)}
// //                   >
// //                     <span className="sb-group-icon">{group.icon}</span>
// //                     <span className="sb-group-label">{group.label}</span>
// //                     <span className={`sb-group-arrow ${openKey === group.key ? 'open' : ''}`}>▼</span>
// //                   </button>
// //                   <div className={`sb-dropdown ${openKey === group.key ? 'open' : ''}`}>
// //                     {group.links.map((link) => (
// //                       <Link
// //                         key={link.to}
// //                         to={link.to}
// //                         className={`sb-link ${location.pathname === link.to ? 'active-link' : ''}`}
// //                         onClick={() => setSidebarOpen(false)}
// //                       >
// //                         <span className="sb-link-icon">{link.icon}</span>
// //                         {link.label}
// //                       </Link>
// //                     ))}
// //                   </div>
// //                 </div>
// //               ))}

// //               <div className="sb-divider" />
// //               <div className="sb-section-label">System</div>

// //               {authMenu.map((link) => (
// //                 <Link
// //                   key={link.to}
// //                   to={link.to}
// //                   className={`sb-footer-link ${location.pathname === link.to ? 'active-link' : ''}`}
// //                   style={{ display: 'flex', alignItems: 'center', gap: 9 }}
// //                   onClick={() => setSidebarOpen(false)}
// //                 >
// //                   <span>{link.icon}</span> {link.label}
// //                 </Link>
// //               ))}
// //             </nav>

// //             {/* Footer */}
// //             <div className="sb-footer">
// //               <button className="sb-footer-link logout" onClick={handleLogout}>
// //                 🚪 Logout
// //               </button>
// //             </div>
// //           </aside>
// //         )}

// //         {/* Mobile toggle */}
// //         {!isStudentOrTeacher && (
// //           <button className="sb-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
// //             {sidebarOpen ? '✕' : '☰'}
// //           </button>
// //         )}
// //       </div>
// //     </>
// //   );
// // }





// import React, { useState, useContext, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { useAuth } from './AuthContext';
// import { useSessions } from './SessionContext';
// import AcademicSessionContext from './AcademicSessionContext';
// import authService from './services/authService';

// const menuItems = {
//   Admin: [
//     {
//       key: 'admission', label: 'Student Information', icon: '🎓',
//       links: [
//         { to: '/admission-form', icon: '➕', label: 'Create Admission' },
//         { to: '/promote-students', icon: '⬆️', label: 'Promote Students' },
//         { to: '/admission-list', icon: '📋', label: 'Admission List' },
//         { to: '/create-class', icon: '🏫', label: 'Create Class' },
//         { to: '/create-section', icon: '🗂️', label: 'Create Section' },
//         { to: '/create-fee-group', icon: '💰', label: 'Create Fee Group' },
//         { to: '/select-categories', icon: '🏷️', label: 'Create Categories' },
//         { to: '/student-id-card-generate', icon: '🪪', label: 'Student ID Card' },
//         { to: '/student-accounts', icon: '👤', label: 'Student Accounts' },
//         { to: '/create-house-and-club', icon: '🏠', label: 'Create House/Club' },
//       ],
//     },
//     {
//       key: 'attendance', label: 'Attendance', icon: '✅',
//       links: [
//         { to: '/student-attendance-list', icon: '🧑‍🎓', label: 'Student Attendance' },
//         { to: '/attendance-list', icon: '👥', label: 'Employee Attendance' },
//         { to: '/real-time-attendance-dashboard', icon: '📡', label: 'Biometric (DB)' },
//       ],
//     },
//     {
//       key: 'exam', label: 'Exam', icon: '📝',
//       links: [
//         { to: '#', icon: '➕', label: 'Create Exam' },
//         { to: '#', icon: '✏️', label: 'Add Marks' },
//         { to: '#', icon: '📄', label: 'Exam Report' },
//       ],
//     },
//     {
//       key: 'fee', label: 'Fee', icon: '🧾',
//       links: [
//         { to: '/bank-details-form', icon: '🏦', label: 'Bank Detail' },
//         { to: '/bank-notes', icon: '📌', label: 'Voucher Notes' },
//         { to: '/heads', icon: '💳', label: 'Fee Head' },
//         { to: '/fee-head-details', icon: 'ℹ️', label: 'Fee Head Details' },
//         { to: '/fee-generate', icon: '🧮', label: 'Fee Generate' },
//         { to: '/fee-vouchers', icon: '🎟️', label: 'Fee Vouchers' },
//         { to: '/fee-post', icon: '📤', label: 'Fee Post' },
//         { to: '/fee-post-all', icon: '☁️', label: 'Fee Post All' },
//         { to: '/fee-reports', icon: '📊', label: 'Fee Reports' },
//       ],
//     },
//     {
//       key: 'hr', label: 'HR', icon: '👥',
//       links: [
//         { to: '/employee-form', icon: '➕', label: 'Add Employee' },
//         { to: '/employee-list', icon: '👥', label: 'Employee List' },
//         { to: '/employee-id-card-generate', icon: '🪪', label: 'Employee ID Card' },
//         { to: '/increments-pay-scale-wise', icon: '⬆️', label: 'Increments' },
//         { to: '/overtime', icon: '⏰', label: 'Overtime' },
//         { to: '/salary-of-employee', icon: '💵', label: 'Generate Salary' },
//         { to: '/school-salary-list', icon: '📋', label: 'Salary List' },
//         { to: '/employee-discipline-form', icon: '🛡️', label: 'Employee Discipline' },
//         { to: '/salary-reports', icon: '📈', label: 'Salary Report' },
//       ],
//     },
//     {
//       key: 'website', label: 'Website', icon: '🌐',
//       links: [
//         { to: '/notification', icon: '🔔', label: 'Notification' },
//         { to: '/event-photos-get', icon: '🖼️', label: 'Events Photo' },
//         { to: '/apply-now-list', icon: '📋', label: 'Apply Now List' },
//       ],
//     },
//     {
//       key: 'academics', label: 'Academics', icon: '📚',
//       links: [
//         { to: '/create-subject', icon: '📖', label: 'Create Subject' },
//         { to: '/assign-subjects', icon: '✅', label: 'Assign Subject' },
//         { to: '/assign-subject-teacher', icon: '👨‍🏫', label: 'Assign Subject Teacher' },
//         { to: '/create-timetable', icon: '📅', label: 'Create Time Table' },
//         { to: '/student-activities', icon: '🏃', label: 'Student Activities' },
//         { to: '/student-discipline-form', icon: '🛡️', label: 'Student Discipline' },
//       ],
//     },
//     {
//       key: 'finance', label: 'Finance', icon: '⚖️',
//       links: [
//         { to: '/charts-of-account-head', icon: '🗂️', label: 'COA (Head)' },
//         { to: '/charts-of-account', icon: '📊', label: 'Charts Of Account' },
//         { to: '/create-voucher', icon: '🧾', label: 'Create Voucher' },
//         { to: '/finance-report', icon: '📉', label: 'Finance Report' },
//       ],
//     },
//   ],
//   Student: [
//     {
//       key: 'lms', label: 'LMS', icon: '🎓',
//       links: [
//         { to: '/student-profile', icon: '👤', label: 'Student Profile' },
//         { to: '/promote-students', icon: '📅', label: 'Time Table' },
//         { to: '/admission-list', icon: '📚', label: 'Class Syllabus' },
//         { to: '/fee-vouchers', icon: '🎟️', label: 'Fee Vouchers' },
//         { to: '/create-section', icon: '📖', label: 'Home Work' },
//       ],
//     },
//   ],
// };

// const authMenu = [
//   { to: '/add-campus-information', icon: '🏫', label: 'Campus Information' },
//   { to: '/view-logs', icon: '🕓', label: 'Logs' },
// ];

// export default function Sidebar() {
//   const [openKey, setOpenKey] = useState(null);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const { user } = useAuth();
//   const { getSessions } = useSessions();
//   const { academicSession, setAcademicSession } = useContext(AcademicSessionContext);
//   const location = useLocation();

//   const userType = user?.user?.user_type;
//   const isStudentOrTeacher = userType === 'Student' || userType === 'Teacher';

//   useEffect(() => {
//     const defaultSession = getSessions.find(s => s.status === 'On');
//     if (defaultSession) setAcademicSession(defaultSession.id);
//   }, [getSessions, setAcademicSession]);

//   const toggle = (key) => setOpenKey(openKey === key ? null : key);

//   const handleLogout = () => {
//     authService.logout();
//     window.location.reload();
//   };

//   const items = menuItems[userType] || [];

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');

//         :root {
//           --green-50: #f0fdf4;
//           --green-100: #dcfce7;
//           --green-200: #bbf7d0;
//           --green-500: #22c55e;
//           --green-600: #16a34a;
//           --green-700: #15803d;
//           --sidebar-w: 260px;
//           --transition: 0.25s cubic-bezier(.4,0,.2,1);
//         }

//         * { box-sizing: border-box; margin: 0; padding: 0; }
//         .sb-root { font-family: 'Nunito', sans-serif; }

//         .sb-overlay {
//           display: none; position: fixed; inset: 0;
//           background: rgba(0,0,0,.35); z-index: 998;
//           backdrop-filter: blur(2px);
//         }
//         .sb-overlay.active { display: block; }

//         .sb-wrap {
//           position: fixed; top: 0; left: 0;
//           height: 100vh; width: var(--sidebar-w);
//           background: #fff;
//           border-right: 1.5px solid var(--green-100);
//           display: flex; flex-direction: column;
//           z-index: 999;
//           transform: translateX(-100%);
//           transition: transform var(--transition);
//           box-shadow: 4px 0 24px rgba(34,197,94,.08);
//           overflow: hidden;
//         }
//         .sb-wrap.open { transform: translateX(0); }
//         @media (min-width: 1024px) { .sb-wrap { transform: translateX(0); } }

//         .sb-brand {
//           padding: 18px 16px 14px;
//           background: linear-gradient(135deg, var(--green-600), var(--green-500));
//           display: flex; align-items: center; gap: 10px; flex-shrink: 0;
//         }
//         .sb-brand-icon {
//           width: 36px; height: 36px; background: rgba(255,255,255,.2);
//           border-radius: 10px; display: flex; align-items: center;
//           justify-content: center; font-size: 17px; flex-shrink: 0;
//         }
//         .sb-brand-text { color: #fff; }
//         .sb-brand-text h2 { font-size: 14px; font-weight: 800; line-height: 1.2; }
//         .sb-brand-text span { font-size: 10.5px; opacity: .85; font-weight: 500; }

//         .sb-dashboard {
//           margin: 12px 12px 4px;
//           display: flex; align-items: center; gap: 10px;
//           padding: 9px 14px; border-radius: 10px;
//           background: var(--green-50); border: 1.5px solid var(--green-100);
//           color: var(--green-700); font-size: 13px; font-weight: 700;
//           text-decoration: none; transition: background var(--transition); flex-shrink: 0;
//         }
//         .sb-dashboard:hover { background: var(--green-100); }

//         .sb-nav {
//           flex: 1; overflow-y: auto; padding: 4px 12px 8px;
//           scrollbar-width: thin; scrollbar-color: var(--green-200) transparent;
//         }
//         .sb-nav::-webkit-scrollbar { width: 4px; }
//         .sb-nav::-webkit-scrollbar-thumb { background: var(--green-200); border-radius: 4px; }

//         .sb-section-label {
//           font-size: 10px; font-weight: 700; color: #9ca3af;
//           letter-spacing: .8px; text-transform: uppercase; padding: 10px 6px 4px;
//         }

//         .sb-group { margin-bottom: 2px; }
//         .sb-group-btn {
//           width: 100%; display: flex; align-items: center; gap: 10px;
//           padding: 9px 12px; border: none; background: transparent;
//           border-radius: 9px; cursor: pointer;
//           font-family: 'Nunito', sans-serif; font-size: 13px; font-weight: 600;
//           color: #374151; transition: background var(--transition), color var(--transition);
//           text-align: left;
//         }
//         .sb-group-btn:hover, .sb-group-btn.active {
//           background: var(--green-50); color: var(--green-700);
//         }
//         .sb-group-icon { font-size: 15px; flex-shrink: 0; }
//         .sb-group-label { flex: 1; }
//         .sb-group-arrow { font-size: 10px; transition: transform var(--transition); color: #9ca3af; }
//         .sb-group-arrow.open { transform: rotate(180deg); }

//         .sb-dropdown { overflow: hidden; max-height: 0; transition: max-height 0.3s cubic-bezier(.4,0,.2,1); }
//         .sb-dropdown.open { max-height: 600px; }

//         .sb-link {
//           display: flex; align-items: center; gap: 9px;
//           padding: 7px 12px 7px 36px; border-radius: 8px;
//           color: #4b5563; text-decoration: none;
//           font-size: 12.5px; font-weight: 500;
//           transition: background var(--transition), color var(--transition);
//           margin-bottom: 1px;
//         }
//         .sb-link:hover, .sb-link.active-link { background: var(--green-50); color: var(--green-700); }
//         .sb-link.active-link { background: var(--green-100); font-weight: 700; }
//         .sb-link-icon { font-size: 13px; }

//         .sb-divider { height: 1px; background: var(--green-100); margin: 8px 0; }

//         .sb-footer-link {
//           display: flex; align-items: center; gap: 9px;
//           padding: 8px 12px; border-radius: 9px; color: #4b5563;
//           text-decoration: none; font-size: 12.5px; font-weight: 600;
//           transition: background var(--transition), color var(--transition);
//           margin-bottom: 2px; background: transparent; border: none; cursor: pointer;
//           font-family: 'Nunito', sans-serif; width: 100%; text-align: left;
//         }
//         .sb-footer-link:hover { background: var(--green-50); color: var(--green-700); }
//         .sb-footer-link.logout:hover { background: #fef2f2; color: #dc2626; }

//         /* ── User card ── */
//         .sb-footer {
//           padding: 10px 12px 14px;
//           border-top: 1.5px solid var(--green-100);
//           flex-shrink: 0;
//         }

//         .sb-user-card {
//           display: flex; align-items: center; gap: 9px;
//           background: var(--green-50);
//           border: 1.5px solid var(--green-100);
//           border-radius: 10px;
//           padding: 9px 10px;
//           margin-bottom: 8px;
//         }
//         .sb-user-avatar {
//           width: 32px; height: 32px; flex-shrink: 0;
//           background: linear-gradient(135deg, var(--green-600), var(--green-500));
//           border-radius: 8px;
//           display: flex; align-items: center; justify-content: center;
//           color: #fff; font-size: 13px; font-weight: 800;
//         }
//         .sb-user-info { flex: 1; min-width: 0; }
//         .sb-user-name {
//           font-size: 12px; font-weight: 700; color: #1f2937;
//           white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//         }
//         .sb-user-campus {
//           font-size: 10.5px; color: #6b7280; font-weight: 500;
//           white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//         }
//         .sb-user-role {
//           font-size: 9.5px; font-weight: 700;
//           background: var(--green-100); color: var(--green-700);
//           padding: 2px 7px; border-radius: 20px; flex-shrink: 0;
//         }

//         /* ── Session row ── */
//         .sb-session-row {
//           display: flex; align-items: center; gap: 0;
//           background: #fff; border: 1.5px solid var(--green-100);
//           border-radius: 9px; overflow: hidden; margin-bottom: 6px;
//           transition: border-color .2s;
//         }
//         .sb-session-row:focus-within {
//           border-color: var(--green-500);
//           box-shadow: 0 0 0 3px rgba(34,197,94,.1);
//         }
//         .sb-session-icon {
//           width: 34px; height: 34px;
//           background: var(--green-50);
//           border-right: 1.5px solid var(--green-100);
//           display: flex; align-items: center; justify-content: center;
//           font-size: 13px; flex-shrink: 0;
//         }
//         .sb-session-select {
//           border: none; outline: none; background: transparent;
//           font-family: 'Nunito', sans-serif;
//           font-size: 12px; font-weight: 600; color: #374151;
//           padding: 0 8px; height: 34px; width: 100%; cursor: pointer;
//         }

//         /* ── Toggle ── */
//         .sb-toggle {
//           position: fixed; top: 14px; left: 14px; z-index: 1000;
//           width: 42px; height: 42px; border-radius: 10px;
//           background: var(--green-600); color: #fff;
//           border: none; cursor: pointer; font-size: 18px;
//           display: flex; align-items: center; justify-content: center;
//           box-shadow: 0 4px 14px rgba(22,163,74,.35);
//           transition: background var(--transition), transform var(--transition);
//         }
//         .sb-toggle:hover { background: var(--green-700); transform: scale(1.05); }
//         @media (min-width: 1024px) { .sb-toggle { display: none; } }
//       `}</style>

//       <div className="sb-root">
//         <div className={`sb-overlay ${sidebarOpen ? 'active' : ''}`} onClick={() => setSidebarOpen(false)} />

//         {!isStudentOrTeacher && (
//           <aside className={`sb-wrap ${sidebarOpen ? 'open' : ''}`}>

//             {/* Brand */}
//             <div className="sb-brand">
//               <div className="sb-brand-icon">🏫</div>
//               <div className="sb-brand-text">
//                 <h2>School ERP</h2>
//                 <span>Management System</span>
//               </div>
//             </div>

//             {/* Dashboard */}
//             <Link to="/" className="sb-dashboard" onClick={() => setSidebarOpen(false)}>
//               🏠 <span>Dashboard</span>
//             </Link>

//             {/* Nav */}
//             <nav className="sb-nav">
//               {userType === 'Admin' && <div className="sb-section-label">Main Menu</div>}

//               {items.map((group) => (
//                 <div className="sb-group" key={group.key}>
//                   <button
//                     className={`sb-group-btn ${openKey === group.key ? 'active' : ''}`}
//                     onClick={() => toggle(group.key)}
//                   >
//                     <span className="sb-group-icon">{group.icon}</span>
//                     <span className="sb-group-label">{group.label}</span>
//                     <span className={`sb-group-arrow ${openKey === group.key ? 'open' : ''}`}>▼</span>
//                   </button>
//                   <div className={`sb-dropdown ${openKey === group.key ? 'open' : ''}`}>
//                     {group.links.map((link) => (
//                       <Link
//                         key={link.to} to={link.to}
//                         className={`sb-link ${location.pathname === link.to ? 'active-link' : ''}`}
//                         onClick={() => setSidebarOpen(false)}
//                       >
//                         <span className="sb-link-icon">{link.icon}</span>
//                         {link.label}
//                       </Link>
//                     ))}
//                   </div>
//                 </div>
//               ))}

//               <div className="sb-divider" />
//               <div className="sb-section-label">System</div>

//               {authMenu.map((link) => (
//                 <Link
//                   key={link.to} to={link.to}
//                   className={`sb-footer-link ${location.pathname === link.to ? 'active-link' : ''}`}
//                   style={{ display: 'flex', alignItems: 'center', gap: 9 }}
//                   onClick={() => setSidebarOpen(false)}
//                 >
//                   <span>{link.icon}</span> {link.label}
//                 </Link>
//               ))}
//             </nav>

//             {/* Footer */}
//             <div className="sb-footer">

//               {/* User card */}
//               <div className="sb-user-card">
//                 <div className="sb-user-avatar">
//                   {user?.user?.username?.charAt(0).toUpperCase() || 'U'}
//                 </div>
//                 <div className="sb-user-info">
//                   <div className="sb-user-name">{user?.user?.username || 'User'}</div>
//                   <div className="sb-user-campus">{user?.user?.campus_name || '—'}</div>
//                 </div>
//                 <div className="sb-user-role">{userType}</div>
//               </div>

//               {/* Session selector */}
//               <div className="sb-session-row">
//                 <span className="sb-session-icon">📅</span>
//                 <select
//                   className="sb-session-select"
//                   value={academicSession}
//                   onChange={e => setAcademicSession(e.target.value)}
//                 >
//                   <option value="">Select Session</option>
//                   {getSessions.map(s => (
//                     <option key={s.id} value={s.id}>{s.session_name}</option>
//                   ))}
//                 </select>
//               </div>

//               {/* Logout */}
//               <button className="sb-footer-link logout" onClick={handleLogout}>
//                 🚪 Logout
//               </button>

//             </div>
//           </aside>
//         )}

//         {!isStudentOrTeacher && (
//           <button className="sb-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
//             {sidebarOpen ? '✕' : '☰'}
//           </button>
//         )}
//       </div>
//     </>
//   );
// }



import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useSessions } from './SessionContext';
import AcademicSessionContext from './AcademicSessionContext';
import authService from './services/authService';

const menuItems = {
  Admin: [
    {
      key: 'admission', label: 'Student Information', icon: '🎓',
      links: [
        { to: '/admission-form', icon: '➕', label: 'Create Admission' },
        { to: '/promote-students', icon: '⬆️', label: 'Promote Students' },
        { to: '/admission-list', icon: '📋', label: 'Admission List' },
        { to: '/create-class', icon: '🏫', label: 'Create Class' },
        { to: '/create-section', icon: '🗂️', label: 'Create Section' },
        // { to: '/create-fee-group', icon: '💰', label: 'Create Fee Group' },
       
        // { to: '/student-id-card-generate', icon: '🪪', label: 'Student ID Card' },
        // { to: '/student-accounts', icon: '👤', label: 'Student Accounts' },
        { to: '/create-house-and-club', icon: '🏠', label: 'Create House/Club' },
      ],
    },
    // {
      // key: 'attendance', label: 'Attendance', icon: '✅',
      // links: [
        // { to: '/student-attendance-list', icon: '🧑', label: 'Student Attendance' },
        // { to: '/attendance-list', icon: '👥', label: 'Employee Attendance' },
        // { to: '/real-time-attendance-dashboard', icon: '📡', label: 'Biometric (DB)' },
      // ],
    // },
    {
      key: 'exam', label: 'Exam', icon: '📝',
      links: [
        { to: '/create-exam', icon: '➕', label: 'Create Exam' },
        { to: '/add-exam-marks', icon: '✏️', label: 'Add Marks' },
        { to: '/exam-report', icon: '📄', label: 'Exam Report' },
      ],
    },
    {
      key: 'fee', label: 'Fee', icon: '🧾',
      links: [
        // { to: '/bank-details-form', icon: '🏦', label: 'Bank Detail' },
        // { to: '/bank-notes', icon: '📌', label: 'Voucher Notes' },
         { to: '/select-categories', icon: '🏷️', label: 'Create Categories' },
          { to: '/create-fee-group', icon: '💰', label: 'Create Fee Group' },
        { to: '/heads', icon: '💳', label: 'Fee Head' },
        { to: '/fee-head-details', icon: 'ℹ️', label: 'Fee Head Details' },
        // { to: '/fee-generate', icon: '🧮', label: 'Fee Generate' },
        // { to: '/fee-vouchers', icon: '🎟️', label: 'Fee Vouchers' },
        // { to: '/fee-post', icon: '📤', label: 'Fee Post' },
        // { to: '/fee-post-all', icon: '☁️', label: 'Fee Post All' },
        // { to: '/fee-reports', icon: '📊', label: 'Fee Reports' },
      ],
    },
    {
      key: 'hr', label: 'HR', icon: '👥',
      links: [
        { to: '/employee-form', icon: '➕', label: 'Add Employee' },
        { to: '/employee-list', icon: '👥', label: 'Employee List' },
        { to: '/teacher-account', icon: '🛡️', label: 'Teacher Account' }
        // { to: '/employee-id-card-generate', icon: '🪪', label: 'Employee ID Card' },
        // { to: '/increments-pay-scale-wise', icon: '⬆️', label: 'Increments' },
        // { to: '/overtime', icon: '⏰', label: 'Overtime' },
        // { to: '/salary-of-employee', icon: '💵', label: 'Generate Salary' },
        // { to: '/school-salary-list', icon: '📋', label: 'Salary List' },
        // { to: '/employee-discipline-form', icon: '🛡️', label: 'Employee Discipline' },
        // { to: '/salary-reports', icon: '📈', label: 'Salary Report' },
      ],
    },
    {
      key: 'website', label: 'Website', icon: '🌐',
      links: [
        { to: '/notification', icon: '🔔', label: 'Notification' },
        { to: '/event-photos-get', icon: '🖼️', label: 'Events Photo' },
        { to: '/apply-now-list', icon: '📋', label: 'Apply Now List' },
         { to: '/downloads', icon: '⬆️', label: 'Upload Downloads' },
        { to: '/admin/blogs', icon: '📂', label: 'Blogs' },
        { to: '/alumni', icon: '🛡️', label: 'Alumni' },
        { to: '/club', icon: '📈', label: 'Club' },
      ],
    },
    {
      key: 'academics', label: 'Academics', icon: '📚',
      links: [
        { to: '/create-subject', icon: '📖', label: 'Create Subject' },
        { to: '/assign-subjects', icon: '✅', label: 'Assign Subject' },
        { to: '/assign-subject-teacher', icon: '👨‍🏫', label: 'Assign Subject Teacher' }
        // { to: '/create-timetable', icon: '📅', label: 'Create Time Table' },
        // { to: '/student-activities', icon: '🏃', label: 'Student Activities' },
        // { to: '/student-discipline-form', icon: '🛡️', label: 'Student Discipline' },
      ],
    },
    // {
    //   key: 'finance', label: 'Finance', icon: '⚖️',
    //   links: [
    //     { to: '/charts-of-account-head', icon: '🗂️', label: 'COA (Head)' },
    //     { to: '/charts-of-account', icon: '📊', label: 'Charts Of Account' },
    //     { to: '/create-voucher', icon: '🧾', label: 'Create Voucher' },
    //     { to: '/finance-report', icon: '📉', label: 'Finance Report' },
    //   ],
    // },
  ],
  Student: [
    {
      key: 'lms', label: 'LMS', icon: '🎓',
      links: [
        { to: '/student-profile', icon: '👤', label: 'Student Profile' },
        { to: '/promote-students', icon: '📅', label: 'Time Table' },
        { to: '/admission-list', icon: '📚', label: 'Class Syllabus' },
        { to: '/fee-vouchers', icon: '🎟️', label: 'Fee Vouchers' },
        { to: '/create-section', icon: '📖', label: 'Home Work' },
      ],
    },
  ],
};

const authMenu = [
  { to: '/password-reset', icon: '👤', label: 'Password Reset' }
  // { to: '/view-logs', icon: '🕓', label: 'Logs' },
];

export default function Sidebar() {
  const [openKey, setOpenKey] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const { getSessions } = useSessions();
  const { academicSession, setAcademicSession } = useContext(AcademicSessionContext);
  const location = useLocation();

  const userType = user?.user?.user_type;
  const isStudentOrTeacher = userType === 'Student' || userType === 'Teacher';

  useEffect(() => {
    const defaultSession = getSessions.find(s => s.status === 'On');
    if (defaultSession) setAcademicSession(defaultSession.id);
  }, [getSessions, setAcademicSession]);

  const toggle = (key) => setOpenKey(openKey === key ? null : key);

  const handleLogout = () => {
    authService.logout();
    window.location.reload();
  };

  const items = menuItems[userType] || [];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');

        :root {
          --green-50: #f0fdf4;
          --green-100: #dcfce7;
          --green-200: #bbf7d0;
          --green-500: #22c55e;
          --green-600: #16a34a;
          --green-700: #15803d;
          --sidebar-w: 260px;
          --transition: 0.25s cubic-bezier(.4,0,.2,1);
        }

        * { box-sizing: border-box; margin: 0; padding: 0; }
        .sb-root { font-family: 'Nunito', sans-serif; }

        .sb-overlay {
          display: none; position: fixed; inset: 0;
          background: rgba(0,0,0,.35); z-index: 998;
          backdrop-filter: blur(2px);
        }
        .sb-overlay.active { display: block; }

        .sb-wrap {
          position: fixed; top: 0; left: 0;
          height: 100vh; width: var(--sidebar-w);
          background: #fff;
          border-right: 1.5px solid var(--green-100);
          display: flex; flex-direction: column;
          z-index: 999;
          transform: translateX(-100%);
          transition: transform var(--transition);
          box-shadow: 4px 0 24px rgba(34,197,94,.08);
          overflow: hidden;
        }
        .sb-wrap.open { transform: translateX(0); }
        @media (min-width: 1024px) { .sb-wrap { transform: translateX(0); } }

        .sb-brand {
          padding: 18px 16px 14px;
          background: #064e3b;
          display: flex; align-items: center; gap: 10px; flex-shrink: 0;
        }
        .sb-brand-icon {
          width: 36px; height: 36px; background: rgba(255,255,255,.2);
          border-radius: 10px; display: flex; align-items: center;
          justify-content: center; font-size: 17px; flex-shrink: 0;
        }
        .sb-brand-text { color: #fff; }
        .sb-brand-text h2 { font-size: 14px; font-weight: 800; line-height: 1.2; }
        .sb-brand-text span { font-size: 15.5px; opacity: .85; font-weight: bold; }

        .sb-dashboard {
          margin: 12px 12px 4px;
          display: flex; align-items: center; gap: 10px;
          padding: 9px 14px; border-radius: 10px;
          background: var(--green-50); border: 1.5px solid var(--green-100);
          color: var(--green-700); font-size: 13px; font-weight: 700;
          text-decoration: none; transition: background var(--transition); flex-shrink: 0;
        }
        .sb-dashboard:hover { background: var(--green-100); }

        .sb-nav {
          flex: 1; overflow-y: auto; padding: 4px 12px 8px;
          scrollbar-width: thin;
        }
        .sb-nav::-webkit-scrollbar { width: 4px; }
        .sb-nav::-webkit-scrollbar-thumb { background: var(--green-200); border-radius: 4px; }

        .sb-section-label {
          font-size: 10px; font-weight: 700; color: #9ca3af;
          letter-spacing: .8px; text-transform: uppercase; padding: 10px 6px 4px;
        }

        .sb-group { margin-bottom: 2px; }
        .sb-group-btn {
          width: 100%; display: flex; align-items: center; gap: 10px;
          padding: 9px 12px; border: none; background: transparent;
          border-radius: 9px; cursor: pointer;
          font-family: 'Nunito', sans-serif; font-size: 13px; font-weight: 600;
          color: #374151; transition: background var(--transition), color var(--transition);
          text-align: left;
        }
        .sb-group-btn:hover, .sb-group-btn.active {
          background: var(--green-50); color: var(--green-700);
        }
        .sb-group-icon { font-size: 15px; flex-shrink: 0; }
        .sb-group-label { flex: 1; }
        .sb-group-arrow { font-size: 10px; transition: transform var(--transition); color: #9ca3af; }
        .sb-group-arrow.open { transform: rotate(180deg); }

        .sb-dropdown { overflow: hidden; max-height: 0; transition: max-height 0.3s cubic-bezier(.4,0,.2,1); }
        .sb-dropdown.open { max-height: 600px; }

        .sb-link {
          display: flex; align-items: center; gap: 9px;
          padding: 7px 12px 7px 36px; border-radius: 8px;
          color: #4b5563; text-decoration: none;
          font-size: 12.5px; font-weight: 500;
          transition: background var(--transition), color var(--transition);
          margin-bottom: 1px;
        }
        .sb-link:hover, .sb-link.active-link { background: var(--green-50); color: var(--green-700); }
        .sb-link.active-link { background: var(--green-100); font-weight: 700; }
        .sb-link-icon { font-size: 13px; }

        .sb-divider { height: 1px; background: var(--green-100); margin: 8px 0; }

        .sb-footer-link {
          display: flex; align-items: center; gap: 9px;
          padding: 8px 12px; border-radius: 9px; color: #4b5563;
          text-decoration: none; font-size: 12.5px; font-weight: 600;
          transition: background var(--transition), color var(--transition);
          margin-bottom: 2px; background: transparent; border: none; cursor: pointer;
          font-family: 'Nunito', sans-serif; width: 100%; text-align: left;
        }
        .sb-footer-link:hover { background: var(--green-50); color: var(--green-700); }
        .sb-footer-link.logout:hover { background: #fef2f2; color: #dc2626; }

        /* ── Footer ── */
        .sb-footer {
          padding: 7px 10px 10px;
          border-top: 1.5px solid var(--green-100);
          flex-shrink: 0;
        }

        /* One-line compact bar: avatar | name/campus | session | logout */
        .sb-compact-bar {
          display: flex; align-items: center; gap: 6px;
          background: var(--green-50);
          border: 1.5px solid var(--green-100);
          border-radius: 10px;
          padding: 5px 8px;
        }
        .sb-user-avatar {
          width: 26px; height: 26px; flex-shrink: 0;
          background: #064e3b;
          border-radius: 7px;
          display: flex; align-items: center; justify-content: center;
          color: #fff; font-size: 11px; font-weight: 800;
        }
        .sb-user-info { flex: 1; min-width: 0; }
        .sb-user-name {
          font-size: 11px; font-weight: 700; color: #1f2937;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
          line-height: 1.2;
        }
        .sb-user-campus {
          font-size: 9.5px; color: #6b7280; font-weight: 500;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
          line-height: 1.2;
        }

        /* Compact session inline select */
        .sb-session-mini {
          border: none; outline: none; background: transparent;
          font-family: 'Nunito', sans-serif;
          font-size: 10.5px; font-weight: 600; color: #374151;
          cursor: pointer; max-width: 80px;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }

        /* Compact logout icon button */
        .sb-logout-btn {
          width: 26px; height: 26px; flex-shrink: 0;
          background: transparent; border: none; cursor: pointer;
          border-radius: 7px; font-size: 14px;
          display: flex; align-items: center; justify-content: center;
          transition: background var(--transition);
        }
        .sb-logout-btn:hover { background: #fee2e2; }

        /* ── Session row (keep for focus ring) ── */
        .sb-session-row {
          display: none;
        }
        .sb-session-row:focus-within {
          border-color: var(--green-500);
          box-shadow: 0 0 0 3px rgba(34,197,94,.1);
        }
        .sb-session-icon {
          width: 34px; height: 34px;
          background: var(--green-50);
          border-right: 1.5px solid var(--green-100);
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; flex-shrink: 0;
        }
        .sb-session-select {
          border: none; outline: none; background: transparent;
          font-family: 'Nunito', sans-serif;
          font-size: 12px; font-weight: 600; color: #374151;
          padding: 0 8px; height: 34px; width: 100%; cursor: pointer;
        }

        /* ── Toggle ── */
        .sb-toggle {
          position: fixed; top: 14px; left: 14px; z-index: 1000;
          width: 42px; height: 42px; border-radius: 10px;
          background: var(--green-600); color: #fff;
          border: none; cursor: pointer; font-size: 18px;
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 4px 14px rgba(22,163,74,.35);
          transition: background var(--transition), transform var(--transition);
        }
        .sb-toggle:hover { background: var(--green-700); transform: scale(1.05); }
        @media (min-width: 1024px) { .sb-toggle { display: none; } }
      `}</style>

      <div className="sb-root">
        <div className={`sb-overlay ${sidebarOpen ? 'active' : ''}`} onClick={() => setSidebarOpen(false)} />

        {!isStudentOrTeacher && (
          <aside className={`sb-wrap ${sidebarOpen ? 'open' : ''}`}>

            {/* Brand */}
            <div className="sb-brand">
              <div className="sb-brand-icon">🏫</div>
              <div className="sb-brand-text">
                {/* <h2>School ERP</h2> */}
                <span>Admin Panel</span>
              </div>
            </div>

          

            {/* Nav */}
            <nav className="sb-nav">
              {userType === 'Admin' && <div className="sb-section-label">Main Menu</div>}

              {items.map((group) => (
                <div className="sb-group" key={group.key}>
                  <button
                    className={`sb-group-btn ${openKey === group.key ? 'active' : ''}`}
                    onClick={() => toggle(group.key)}
                  >
                    <span className="sb-group-icon">{group.icon}</span>
                    <span className="sb-group-label">{group.label}</span>
                    <span className={`sb-group-arrow ${openKey === group.key ? 'open' : ''}`}>▼</span>
                  </button>
                  <div className={`sb-dropdown ${openKey === group.key ? 'open' : ''}`}>
                    {group.links.map((link) => (
                      <Link
                        key={link.to} to={link.to}
                        className={`sb-link ${location.pathname === link.to ? 'active-link' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sb-link-icon">{link.icon}</span>
                        {link.label}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}

              <div className="sb-divider" />
              <div className="sb-section-label">System</div>

              {authMenu.map((link) => (
                <Link
                  key={link.to} to={link.to}
                  className={`sb-footer-link ${location.pathname === link.to ? 'active-link' : ''}`}
                  style={{ display: 'flex', alignItems: 'center', gap: 9 }}
                  onClick={() => setSidebarOpen(false)}
                >
                  <span>{link.icon}</span> {link.label}
                </Link>
              ))}
            </nav>

            {/* Footer - compact single bar */}
            <div className="sb-footer">
              <div className="sb-compact-bar">

                {/* Avatar */}
                <div className="sb-user-avatar">
                  {user?.user?.username?.charAt(0).toUpperCase() || 'U'}
                </div>

                {/* Name + Campus */}
                <div className="sb-user-info">
                  <div className="sb-user-name">{user?.user?.username || 'User'}</div>
                  <div className="sb-user-campus">{user?.user?.campus_name || '—'}</div>
                </div>

                {/* Session mini select */}
                <select
                  title="Academic Session"
                  className="sb-session-mini"
                  value={academicSession}
                  onChange={e => setAcademicSession(e.target.value)}
                >
                  <option value="">Session</option>
                  {getSessions.map(s => (
                    <option key={s.id} value={s.id}>{s.session_name}</option>
                  ))}
                </select>

                {/* Logout icon */}
                <button
                  className="sb-logout-btn"
                  onClick={handleLogout}
                  title="Logout"
                >
                  🚪
                </button>

              </div>
            </div>
          </aside>
        )}

        {!isStudentOrTeacher && (
          <button className="sb-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? '✕' : '☰'}
          </button>
        )}
      </div>
    </>
  );
}